import Modal from './modal';

import './styles.css';
import Logo from './images/logo.jpg';

export const Step1 = ({onNext}) => {
  return (
    <Modal className="step-1">
      <img src={Logo} alt="Logo" className="onboarding-logo" />
      <h1>Welcome to Market Games</h1>
      <p><strong>We’re here to help you succeed in Accounting!</strong></p>
      <button className="button onboarding-big-button student-onboarding-big-button" onClick={onNext}>Let’s Get Started</button>
    </Modal>
  )
};